import React, { useState, useCallback, useEffect } from 'react'
import Modal from '@mui/material/Modal'
import { Box, DialogActions, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { Input } from 'Components/Input'
import Button from '@mui/material/Button'
import { makePostRequest, makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import ComboBox from 'Components/ComboBox'
import { makePutRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  boxShadow: 24,
}

export default function UpdateListe({ setUpdateListe, row, updateTodo = false }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [modelOpen, setModelOpen] = useState(true)
  const [upUi, setUpUi] = useState(true)
  const [domain, setDomain] = useState([])
  const [selectedDomain, setSelectedDomain] = useState(null)

  const handleModelClose = () => {
    setModelOpen(false)
    setUpdateListe(false)
    reset()
  }

  const { handleSubmit, control, reset, setValue, getValues } = useForm({
    defaultValues: {
      Name: row.Name || '',
    },
  })
  useEffect(() => {
    fetchDomain()
  }, [])

  const fetchDomain = async () => {
    const url = urls.getDomain + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.domain}`, id: v.id })
      })
      if (row.domain?.id) {
        let ff = filterTypes.filter((e) => e.id === row.domain.id)[0]
        setSelectedDomain(ff)
        setValue('LifeDomain', ff)
      }
      setDomain([...filterTypes])
    }
  }

  const onSubmit = async (data) => {
    let payload = {}
    payload = {
      ...data,
      LifeDomain: data.LifeDomain.id,
    }
    // console.log(payload)
    // return
    const response = await makePutRequest(urls.listeOperations + row.id + '/', payload, {}, true)
    if (response.status === 200) {
      handleModelClose()
      if (updateTodo) updateTodo()
    }
  }
  console.log(row)
  return (
    <>
      <Modal
        open={modelOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={mstyle}>
          <Box>
            <Box
              sx={{ textAlign: 'end', padding: '5px 10px', position: 'relative', zIndex: '999' }}
            >
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleModelClose} />
            </Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-30px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    {t('mesToDo.editList')}
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                      <Input
                        control={control}
                        onChange={(e) => {
                          setValue('Name', e.target.value)
                          setUpUi(!upUi)
                        }}
                        inputProps={{
                          variant: 'outlined',
                          required: true,
                          size: 'small',
                          type: 'text',
                          // maxLength: 10,
                        }}
                        error={getValues('Name').length > 50 ? true : false}
                        rules={{ required: true }}
                        helperText={`50 characters`}
                        name="Name"
                        label={t('mesToDo.fieldListName')}
                      />

                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('LifeDomain', j)
                          setSelectedDomain(j)
                        }}
                        label={t('mesToDo.fieldDomain')}
                        data={domain}
                        name="LifeDomain"
                        required={true}
                        selectedValue={selectedDomain}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button sx={{ marginLeft: 'auto !important' }} type="submit">
                        {t('mesToDo.validate')}
                      </Button>
                    </DialogActions>
                  </form>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}
